import { Select, Form } from 'antd';
import React from 'react';
import { IFacility, IGroup } from '../../../store/modules/facility/i-facility';
import { ITenant } from '../../../store/modules/tenants/i-tenant';
import { IRole } from '../../../store/modules/user/i-role';
import { IStatuses } from '../../../store/modules/devices/i-devices';
import { IEntryValue } from '../../../store/modules/user/i-user';

const { Option } = Select;
interface ISelect {
  title: string;
  defaultValue: string;
  fieldName: string;
  onChange: (value: string | number) => void;
  data: (IRole | ITenant | IFacility | IGroup | IStatuses | IEntryValue)[];
  disabled?: boolean;
  allowEmpty?: boolean;
}

const InputSelect: React.FC<ISelect> = ({
  title, defaultValue, fieldName, onChange, data, disabled, allowEmpty = false,
}: ISelect): JSX.Element => {
  const options = data.map(
    (el) => <Option key={`key=${el.id}`} value={fieldName === 'role_id' ? el.id : el.name || ''}>{el.name}</Option>,
  );

  if (allowEmpty) {
    // eslint-disble-next-line
    options.unshift(<Option value="">None</Option>);
  }

  return (
    <Form.Item label={title}>
      {/*
      <p className="ant-col ant-form-item-label" style={{ margin: '10px 0 5px' }}>{title}</p>
      */}
      <Select
        size="large"
        className="ant__select formik-form__dropdown"
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={disabled}
      >
        {options}
      </Select>
    </Form.Item>
  );
};

InputSelect.displayName = 'InputSelect';

export default InputSelect;
